
import { defineComponent, onMounted } from 'vue';
import animateScrollTo from 'animated-scroll-to';
import { useRoute } from 'vue-router';
import StoryContent from '@/components/StoryContent.vue';
import WorksGrid from '@/components/WorksGrid.vue';
import getStory from '@/sanity/requests/story';
import { useStore } from '@/store';

export default defineComponent({
  name: 'Story',
  components: {
    StoryContent,
    WorksGrid,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const slug = route.params.story as string;

    const scrollTo = (selector: string, offset = 0) => {
      const [el] = document.querySelectorAll(selector);
      if (el !== null && el instanceof HTMLElement) {
        animateScrollTo(el.offsetTop - offset, {
          cancelOnUserAction: false,
          maxDuration: 1000,
        });
      }
    };

    onMounted(() => {
      store.commit.setBackgroundWhite(false);
    });

    const onWorksEnter = () => {
      store.commit.setBackgroundWhite(true);
    };

    const onWorksLeave = () => {
      if (route.name === 'story') {
        store.commit.setBackgroundWhite(false);
      }
    };

    return { ...getStory(slug), scrollTo, onWorksEnter, onWorksLeave };
  },
});
